let previous_stage = false;
let active_stage = 0;

let scroll_allowed = true;

//our scroll listener to detect if the user is moving the mouse
// window.addEventListener("wheel", event => {

// 	//if we're allowed to scroll
// 	if(scroll_allowed && document.body.classList.contains('allow-stage-manager')) {
// 		scroll_allowed = false;
// 		const delta = Math.sign(event.deltaY);

// 		if(previous_stage) {
// 			//log the previous stage
// 			previous_stage = active_stage;
// 		}

// 		//if the mouse movement is down
// 		if(delta == 1) {
// 			//increase the active stage
// 			active_stage++;
// 		} else if(delta == -1 && active_stage > 0) { //if it's going back
// 			//decrease the active stage
// 			active_stage--;
// 		}

// 		update_stage();
// 	}
// });

export default function update_stage(target = false) {

	if(target) {
		previous_stage = active_stage;
		active_stage = target;
	}

	console.log(previous_stage + '/' + active_stage);

	//if the stage has moved
	if(!previous_stage || active_stage != previous_stage) {

		let logo = document.getElementById('logo');
		let links = document.getElementById('links');
		let content = document.getElementById('content');
		let tiles = document.getElementById('tiles');

		//we will do different things depending on the stage
		switch(active_stage) {

			case 0:
				logo.classList.remove('swap');
				links.classList.remove('active');
				content.classList.remove('active');
				tiles.classList.remove('animated');

				setTimeout(function() {
					scroll_allowed = true;
				}, 2000);
				break;
			case 1:
				logo.classList.add('swap');
				links.classList.add('active');

				setTimeout(function() {
					content.classList.add('active');
					tiles.classList.add('animating');

					setTimeout(function() {
						tiles.classList.remove('animating');
						tiles.classList.add('animated');
					}, 1400);
				}, 200)

				

				setTimeout(function() {
					scroll_allowed = true;
				}, 2000);
				break;
		}
	}
}